import React from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useBestFittingImage, useImageLoader } from './hooks';
import { useDumboCommon } from '../../../../DeviationViews/Dumbo/useDumbo';
const DeviationImageCoverView = ({ deviation, containerWidth, containerHeight, className })=>{
    const image = useBestFittingImage(deviation, containerWidth, containerHeight);
    const imageLoaded = useImageLoader(image && image.src);
    const DumboReturn = useDumboCommon({
        deviation,
        width: containerWidth,
        height: containerHeight
    });
    if (!image) {
        return null;
    }
    if (DumboReturn) {
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, DumboReturn);
    }
    const isLargeEnough = image.width >= containerWidth && image.height >= containerHeight;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, imageLoaded ? /*#__PURE__*/ React.createElement("div", {
        style: {
            backgroundImage: `url(${image.src})`,
            backgroundSize: isLargeEnough ? 'cover' : 'auto',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%'
        }
    }) : /*#__PURE__*/ React.createElement(LoadingIndicator, null));
};
export default /*#__PURE__*/ React.memo(DeviationImageCoverView);
